export const viewPorts = {
    mob: 560,
    md: 768,
    mb: 900,
    lg: 1024,
    xsl: 1140,
    xl: 1280,
    xxl: 1536,
}
